<template>

    <div class="position-relative dropdown">
        <a class="" href="#" :id="getUniqueId('inputDate')" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <slot name="input">
                <date-picker
                    popover-visibility="focus"

                    v-model="date"
                >
                    <template #default="{ inputProps, inputEvents }">

                        <input-child
                            v-bind="getInputProps({
                                ...inputProps,
                                type: 'date'
                            })"
                            v-on="inputEvents"

                            v-model="inputValue"
                        ></input-child>

                    </template>
                    <template #day-content="{ day, attributes, contentStyle }">
                        <span :class="{'c-day-custom': true, 'c-day-custom--selected': isSelected( day )}">
                            {{ day.day }}
                        </span>
                    </template>
                </date-picker>


            </slot>
        </a>

    </div>

</template>

<script>
    import mixinCommon from './mixinCommon';
    import mixinInput from './mixinInput';

    import moment from 'moment';

    import { setupCalendar, Calendar, DatePicker } from 'v-calendar';

    import Input from './Input'

    const { props } = Input;

    setupCalendar({
        //componentPrefix: 'vc-',
        firstDayOfWeek: 2
    });

    export default {
        mixins: [ mixinCommon, mixinInput ],

        components: {
            'input-child': Input,
            //'calendar': Calendar,
            'date-picker': DatePicker
        },
        props: {
            ...props,
        },
        computed: {
            date: {
                get() {
                    return new Date( this.inputValue );
                },
                set( date ) {
                    this.inputValue = moment( date ).format('YYYY-MM-DD');
                }
            }
        },

        data() {
            return {
                selectedDay: {
                    date: null
                }
            };
        },
        mounted() {},
        methods: {
            isSelected( day ) {
                return this.inputValue === moment(day.date).format('YYYY-MM-DD');
            },

            getInputProps( overrideProps = {} ) {
                let props = {};
                for( let name in Input.props ) {
                    if( typeof overrideProps[name] !== 'undefined' ) {
                        props[name] = overrideProps[name];
                    }
                    else if( typeof this[name] !== 'undefined' ) {
                        props[name] = this[name];
                    }
                }

                return props;
            }
        }
    };
</script>
